<template>
    <div
        class="d-form-row"
        :class="{'vertical': isVertical}"
    >
        <div
            v-if="label"
            class="label"
            :class="{'required': isRequired}"
        >
            {{ label }}
        </div>
        <div class="content">
            <div class="aside-content">
                <slot name="asideContent" />
            </div>
            <div class="input">
                <slot />
            </div>
            <!-- eslint-disable vue/no-v-html -->
            <div
                v-if="hint"
                class="hint"
                v-html="hint"
            />
            <!--eslint-enable-->
            <div
                v-if="error"
                class="error"
            >
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DFormRow',
    props: {
        label: {
            type: String,
            required: true,
            default: '[Label Missing]'
        },
        isRequired: {
            type: Boolean,
            required: false,
            default: false
        },
        isVertical: {
            type: Boolean,
            required: false,
            default: false
        },
        hint: {
            type: String,
            required: false,
            default: ''
        },
        error: {
            type: String,
            required: false,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.d-form-row {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 10px 15px;

    &.vertical {
        grid-template-columns: 1fr;
        grid-gap: 5px 15px;
    }

    & .label {
        grid-column: 1;
        font-weight: bold;
        padding: 10px 0px;

        &.required::after {
            content: "*";
            color: var(--colorDanger);
        }
    }
    & .content {
        display: grid;
        grid-gap: 5px;
        align-items: center;
        position: relative;
        & .aside-content {
            position: absolute;
            left: -50px;
        }
        & .input {
            & .form-group {
                margin: 0;
            }
        }

        & .error {
            font-size: 12px;
            color: var(--colorDanger);
        }

        & .hint {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.6);
        }
    }

    &:not(:last-child) {
        margin-bottom: 25px;
    }
}
</style>
